import React, { useState, useEffect } from 'react';
import Typewriter from '../components/Typewriter';

function Home() {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    'https://picsum.photos/1920/1080?random=1',
    'https://picsum.photos/1920/1080?random=2',
    'https://picsum.photos/1920/1080?random=3',
    'https://picsum.photos/1920/1080?random=4',
    'https://picsum.photos/1920/1080?random=5'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section id="home" className="hero" style={{position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', margin: 0, padding: 0}}>
        <div className="hero-video-wrapper" style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0}}>
          {images.map((img, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: currentImage === index ? 1 : 0,
                transition: 'opacity 2s ease-in-out',
                animation: currentImage === index ? 'kenburns 20s ease-out' : 'none'
              }}
            />
          ))}
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(15, 23, 42, 0.75)'}}></div>
        </div>
        <div className="hero-content" style={{zIndex: 2, textAlign: 'center', padding: '60px', maxWidth: '1400px'}}>
          <h1 style={{fontFamily: 'Inter, sans-serif', fontSize: 'clamp(2.5rem, 8vw, 6rem)', fontWeight: 900, color: 'white', marginBottom: '30px', letterSpacing: '3px', textShadow: '4px 4px 8px rgba(0,0,0,0.7)', lineHeight: 1.2}}>BETHEL PUBLIC SCHOOL</h1>
          <div style={{height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px'}}>
            <Typewriter />
          </div>
          <p className="hero-subtitle" style={{fontSize: 'clamp(1.1rem, 3vw, 1.8rem)', color: '#e0e7ff', marginBottom: '50px', fontWeight: 600, textShadow: '2px 2px 4px rgba(0,0,0,0.7)'}}>Where every student discovers their potential.</p>
          <div style={{display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'wrap'}}>
            <a href="/about" className="btn" style={{background: '#1e3a8a', color: 'white', padding: '20px 50px', borderRadius: '50px', textDecoration: 'none', fontWeight: 800, fontSize: '1.3rem', boxShadow: '0 10px 30px rgba(30, 58, 138, 0.5)', transition: 'all 0.3s', textTransform: 'uppercase', letterSpacing: '1px', border: '2px solid #1e3a8a'}}>Learn More</a>
            <a href="/contact" className="btn" style={{background: 'transparent', color: 'white', padding: '20px 50px', borderRadius: '50px', textDecoration: 'none', fontWeight: 800, fontSize: '1.3rem', boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)', transition: 'all 0.3s', textTransform: 'uppercase', letterSpacing: '1px', border: '2px solid white'}}>Contact Us</a>
          </div>
        </div>
        <style>{`
          @keyframes kenburns {
            0% { transform: scale(1); }
            100% { transform: scale(1.2); }
          }
        `}</style>
      </section>

      <section style={{background: '#0f172a', padding: '100px 0'}}>
        <div className="container">
          <h2 style={{textAlign: 'center', fontSize: '3.5rem', color: 'white', marginBottom: '70px', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '2px'}}>Why Choose Us</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px'}}>
            <div style={{background: '#1e293b', padding: '50px', borderRadius: '25px', textAlign: 'center', boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)', transition: 'transform 0.3s', border: '2px solid #334155'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-15px)'; e.currentTarget.style.borderColor = '#3b82f6';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#334155';}}>
              <div style={{width: '80px', height: '80px', background: '#1e3a8a', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px'}}>
                <i className="fas fa-graduation-cap" style={{fontSize: '2.5rem', color: 'white'}}></i>
              </div>
              <h3 style={{fontSize: '1.8rem', marginBottom: '20px', fontWeight: 800, color: 'white'}}>Quality Education</h3>
              <p style={{fontSize: '1.1rem', lineHeight: 1.6, color: '#cbd5e0'}}>State Board of Karnataka curriculum with holistic development</p>
            </div>
            <div style={{background: '#1e293b', padding: '50px', borderRadius: '25px', textAlign: 'center', boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)', transition: 'transform 0.3s', border: '2px solid #334155'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-15px)'; e.currentTarget.style.borderColor = '#3b82f6';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#334155';}}>
              <div style={{width: '80px', height: '80px', background: '#1e40af', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px'}}>
                <i className="fas fa-users" style={{fontSize: '2.5rem', color: 'white'}}></i>
              </div>
              <h3 style={{fontSize: '1.8rem', marginBottom: '20px', fontWeight: 800, color: 'white'}}>Small Class Sizes</h3>
              <p style={{fontSize: '1.1rem', lineHeight: 1.6, color: '#cbd5e0'}}>Personal attention with 10:1 student-teacher ratio</p>
            </div>
            <div style={{background: '#1e293b', padding: '50px', borderRadius: '25px', textAlign: 'center', boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)', transition: 'transform 0.3s', border: '2px solid #334155'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-15px)'; e.currentTarget.style.borderColor = '#3b82f6';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#334155';}}>
              <div style={{width: '80px', height: '80px', background: '#2563eb', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px'}}>
                <i className="fas fa-trophy" style={{fontSize: '2.5rem', color: 'white'}}></i>
              </div>
              <h3 style={{fontSize: '1.8rem', marginBottom: '20px', fontWeight: 800, color: 'white'}}>22+ Years Excellence</h3>
              <p style={{fontSize: '1.1rem', lineHeight: 1.6, color: '#cbd5e0'}}>Proven track record of academic success</p>
            </div>
            <div style={{background: '#1e293b', padding: '50px', borderRadius: '25px', textAlign: 'center', boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)', transition: 'transform 0.3s', border: '2px solid #334155'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-15px)'; e.currentTarget.style.borderColor = '#3b82f6';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#334155';}}>
              <div style={{width: '80px', height: '80px', background: '#1d4ed8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px'}}>
                <i className="fas fa-laptop-code" style={{fontSize: '2.5rem', color: 'white'}}></i>
              </div>
              <h3 style={{fontSize: '1.8rem', marginBottom: '20px', fontWeight: 800, color: 'white'}}>Modern Facilities</h3>
              <p style={{fontSize: '1.1rem', lineHeight: 1.6, color: '#cbd5e0'}}>Smart classrooms, STEM lab, and digital learning</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
